import { render } from "./list.vue?vue&type=template&id=4fb1219c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=4fb1219c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fb1219c"

export default script